import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { API_ENDPOINTS, fetchWithCredentials } from '../config/api';
import './ChangePasswordPage.css';

function ChangePasswordPage() {
  const { isLoggedIn } = useAuth();
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {
    if (!formData.currentPassword) {
      setMessage({ type: 'error', text: '請輸入當前密碼' });
      return false;
    }
    if (!formData.newPassword) {
      setMessage({ type: 'error', text: '請輸入新密碼' });
      return false;
    }
    if (formData.newPassword.length < 6) {
      setMessage({ type: 'error', text: '新密碼至少需要6個字符' });
      return false;
    }
    if (formData.newPassword !== formData.confirmPassword) {
      setMessage({ type: 'error', text: '新密碼和確認密碼不匹配' });
      return false;
    }
    if (formData.currentPassword === formData.newPassword) {
      setMessage({ type: 'error', text: '新密碼不能與當前密碼相同' });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await fetchWithCredentials(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, {
        method: 'POST',
        body: JSON.stringify({
          currentPassword: formData.currentPassword,
          newPassword: formData.newPassword
        })
      });

      if (response.success) {
        setMessage({ type: 'success', text: '密碼修改成功！' });
        setFormData({
          currentPassword: '',
          newPassword: '',
          confirmPassword: ''
        });
      } else {
        setMessage({ type: 'error', text: response.message || '密碼修改失敗' });
      }
    } catch (error) {
      console.error('修改密碼失敗:', error);
      setMessage({ 
        type: 'error', 
        text: error.message || '密碼修改失敗，請稍後重試' 
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isLoggedIn) {
    return (
      <div className="change-password-page">
        <div className="container">
          <h1>修改密码</h1>
          <div className="error-message">请先登录</div>
        </div>
      </div>
    );
  }

  return (
    <div className="change-password-page">
      <div className="container">
        <h1>修改密码</h1>
        <p className="subtitle">请填写以下信息来修改您的密码</p>

        <form onSubmit={handleSubmit} className="change-password-form">
          <div className="form-group">
            <label htmlFor="currentPassword">当前密码</label>
            <input
              type="password"
              id="currentPassword"
              name="currentPassword"
              value={formData.currentPassword}
              onChange={handleInputChange}
              placeholder="请输入当前密码"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="newPassword">新密码</label>
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleInputChange}
              placeholder="请输入新密码（至少6个字符）"
              required
            />
            <small className="form-hint">密码至少需要6个字符</small>
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">确认新密码</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              placeholder="请再次输入新密码"
              required
            />
          </div>

          {message.text && (
            <div className={`message ${message.type}`}>
              {message.text}
            </div>
          )}

          <button 
            type="submit" 
            className="submit-btn"
            disabled={loading}
          >
            {loading ? '修改中...' : '修改密码'}
          </button>
        </form>

        <div className="password-tips">
          <h3>密码安全提示</h3>
          <ul>
            <li>使用至少6个字符的密码</li>
            <li>包含大小写字母、数字和特殊字符</li>
            <li>避免使用容易猜测的信息（如生日、姓名等）</li>
            <li>定期更换密码以提高安全性</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordPage; 